import { IGetCargosDropDownUseCase } from "../../../presentation/useCases/read/get_cargos_dropdown_use_case";
import { CargoDropDown } from "../../models/cargo_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetCargosDropDownUseCase
 */

export class GetCargosDropDownUseCase implements IGetCargosDropDownUseCase {
  constructor(
    private readonly repository: ICommonsRepository,
  ) { }

  async getCargosDropDown(): Promise<CargoDropDown[]> {
    const response = await this.repository.getCargosDropDown();
    return response
  }
}